<template>
	<div class="auth">
		<Header></Header>
		<div class="sign_up_page">
			<div class="container">
				<div class="row">
					<div class="col-lg-6 order-2 order-lg-1">
						<div class="sign_up_box">
							<h1>{{ $t('auth.forgot_password.title') }}</h1>
							<p v-if="response">{{ $t('auth.forgot_password.instructions_sent') }}</p>
							<template v-else>
								<p>{{ $t('auth.forgot_password.instructions_intro') }}</p>
								<div class="input_box">
									<div class="label">{{ $t('settings.profile.forms.email.label') }}</div>
									<input
										type="email"
										:placeholder="$t('auth.forgot_password.placeholder_email')"
										v-model="email"
									>
								</div>
								<div v-if="error" class="error_msg">{{ error }}</div>
								<div class="auth-button" :class="button_disabled ? 'active' : ''">
									<a href="#" class="button" @click.prevent="submitForm">
										{{ $t('auth.forgot_password.reset_button') }}
									</a>
									<div class="image-pre-loader image-pre-loader-red"></div>
								</div>
							</template>
							<hr>
							<p class="text-center small">
								<router-link to="/login">{{ $t('auth.forgot_password.back_to_signin') }}</router-link>
							</p>
						</div>
					</div>
					<div class="col-lg-6 order-1 order-lg-2">
						<div class="key_img">
							<img :src="require('@/assets/static/images/auth/key.png')" alt="">
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>


<script>

	import '@/assets/styles/auth/main.scss'
	import { mapMutations, mapActions, mapGetters } from "vuex"

	import Header from '@/components/auth/Header'

	export default {
		data: () => ({
			email: '',
			response: '',
			error: '',
			button_disabled: false
		}),
		components: {
			Header
		},
		mounted() {
			document.head.querySelector("[name~=theme-color][content]").content = '#fff'
			document.head.querySelector("[name~=viewport][content]").content = 'width=device-width,initial-scale=1.0'
			document.querySelector('body').classList.add('responsive')
      document.querySelector('body').classList.add('intropage')
    },
    unmounted() {
      document.querySelector('body').classList.remove('intropage')
    },
		methods: {
			...mapActions(["ForGotPassword"]),
			...mapMutations(["setMessage"]),
			async submitForm() {

				if (this.button_disabled) return

				this.error = ''

				if (!this.email) return this.error = this.$t('auth.forgot_password.error_enter_email')
        if (!this.$w_email_validate(this.email)) return this.error = this.$t('auth.forgot_password.error_invalid_email')

				this.button_disabled = true

				const result = await this.ForGotPassword({
					url: this.$w_api.ForGotPassword,
					body: {
						email: this.email
					}
				})

				if (result) {
					this.response = result
				}

			}
		}
	}

</script>
